// extracted by mini-css-extract-plugin
module.exports = {"crumber":"Crum_crumber__y89Qg","wbg":"Crum_wbg__R6lJi"};